export const INTERVIEW_TECHNOLOGIES = [
  'Java / Spring Boot',
  'MERN',
  '.NET',
  'Python',
  'React',
  'Angular',
  'AI Engineer',
  'System Design',
  'Other',
] as const;

export const INTERVIEW_PAGE = {
  eyebrow: 'Technical Interviews',
  heroTitle: 'Know where you stand before the interview that matters.',
  heroIntro:
    'A realistic session with an industry expert, with feedback you can act on.',
  title: 'Practice the interview that stands between you and the offer',
  intro:
    'A structured technical interview with an industry expert helps you find gaps early, get direct feedback, and walk into real hiring loops with confidence — whether you are a student, fresher, or working engineer changing tracks.',
  includesEyebrow: '60-minute session',
  includes: [
    'Technical interview',
    'System design discussion',
    'Expert feedback',
    'Strengths & gaps',
    'Recommended next steps',
  ],
  durationMinutes: 60,
  durationLabel: 'Duration',
  durationDisplay: '60-minute session',
  listPrice: 0,
  displayPrice: 0,
  discountPercent: 0,
  priceLabel: 'Technical Interview',
  limitedOfferNote: '40% off for a limited period',
  formNote:
    'Tell us your stack and role. Sessions are 60 minutes. Technical Interview is ₹1,999 — currently ₹1,199 (40% off for a limited period).',
  ctaRequest: 'Book a Technical Interview',
} as const;
